import '@viapeople/components/src/tailwind.config.css'
import './global.css'

import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ErrorFallback, initSentry } from '@viapeople/components'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './Routes.tsx'
import { ToastProvider } from './utils/ToastContext.tsx'
import { queryClient } from './utils/trpc'

initSentry({
	dsn: import.meta.env.VITE_ADMIN_SENTRY_DSN,
	environment: import.meta.env.VITE_ENVIRONMENT || 'local',
	appName: 'admin',
	release: import.meta.env.VITE_SENTRY_RELEASE,
})

createRoot(document.getElementById('root') as HTMLElement).render(
	<Sentry.ErrorBoundary fallback={<ErrorFallback />}>
		<StrictMode>
			<QueryClientProvider client={queryClient}>
				<ToastProvider>
					<RouterProvider router={router} />
				</ToastProvider>
			</QueryClientProvider>
		</StrictMode>
	</Sentry.ErrorBoundary>,
)
